import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from '@material-ui/core/Hidden';
import { AppContext } from 'store/AppContext';
import DrawerContent from './components/DrawerContent';


const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  drawerPaper: {
    width: drawerWidth,
  },
}));


const Sidebar = () => {
  const classes = useStyles();
  const context = useContext(AppContext);
  const mobileOpen = context.drawer.get.mobileOpen;

  const handleDrawerToggle = () => {
    context.drawer.set(prevState => {
      return { ...prevState, mobileOpen: !context.drawer.get.mobileOpen };
    });
  };

  return (
    <nav className={classes.drawer} aria-label="application folders">
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <Hidden xsDown implementation="css">
        <Drawer
          variant="temporary"
          anchor="left"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <DrawerContent />
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          classes={{
            paper: classes.drawerPaper,
          }}
          variant="permanent"
          open
        >
          <DrawerContent />
        </Drawer>
      </Hidden>
    </nav>
  );
}

export default Sidebar;